import { render } from "./UnsupportedTrailerTypeOverlay.vue?vue&type=template&id=43007c0b&ts=true"
import script from "./UnsupportedTrailerTypeOverlay.vue?vue&type=script&lang=ts"
export * from "./UnsupportedTrailerTypeOverlay.vue?vue&type=script&lang=ts"

import "./UnsupportedTrailerTypeOverlay.vue?vue&type=style&index=0&id=43007c0b&lang=scss"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__